import { Component } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConsentService } from '../services/consent.service';

@Component({
    selector: 'app-cookie-banner',
    templateUrl: './cookie-banner.component.html',
    styleUrls: ['./cookie-banner.component.scss'],
    imports: [TranslateModule],
})
export class CookieBannerComponent {
  constructor(
    public consentService: ConsentService,
    public translate: TranslateService
  ) {}

  get showBanner(): boolean {
    return !this.consentService.hasDecided();
  }

  accept(): void {
    this.consentService.accept();
  }

  reject(): void {
    this.consentService.reject();
  }
}
